const ITEMS = [
  "Join the flock",
  "Your membership matters",
  "Congrats Allen Lou — Grand Prize Winner",
  "Make this school year even more fun",
  "$100,000 raised last year",
  "Corporate matching available",
];

export const Marquee = () => (
  <div data-testid="marquee-strip" className="relative bg-slate-950 py-5 overflow-hidden select-none">
    <div className="neon-hairline absolute top-0 left-0 right-0" />
    <div className="neon-hairline absolute bottom-0 left-0 right-0" />
    <div className="marquee-track flex whitespace-nowrap items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((t, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span className="mx-8 text-lg md:text-2xl font-black uppercase tracking-wider text-transparent" style={{ WebkitTextStroke: "1px rgba(0,240,255,0.8)" }}>
                {t}
              </span>
              <span className="text-pink-500 text-xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
